module.exports = __webpack_public_path__ + "de5f73f63248bb88951aef8854eed8db.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1159
// module chunks = 0